export default __webpack_public_path__ + "static/meltone-b247e1a38ae34250f8b442a7b0df4f4e.png";